import { useState, useEffect } from "react"

const useLocalStorageListener = (key, initialValue) => {
  const [value, setValue] = useState(() => {
    try {
      const item = localStorage.getItem(key)
      return item ? JSON.parse(item) : initialValue
    } catch (error) {
      return initialValue
    }
  })

  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === key) {
        try {
          setValue(e.newValue ? JSON.parse(e.newValue) : initialValue)
        } catch {
          setValue(initialValue)
        }
      }
    }

    const handleCustomEvent = (e) => {
      if (e.detail.key === key) {
        setValue(e.detail.value)
      }
    }

    window.addEventListener("storage", handleStorageChange)
    window.addEventListener("localStorageChange", handleCustomEvent)

    return () => {
      window.removeEventListener("storage", handleStorageChange)
      window.removeEventListener("localStorageChange", handleCustomEvent)
    }
  }, [key, initialValue])

  return value
}

export default useLocalStorageListener
